import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { loginSuccess, logout } from "../redux/reducers/auth";
import AuthAPI from "../api/authAPI";


const Protect = (props) => {
  const { user } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    // Always check backend session on route change
    AuthAPI.getCurrentUser()
      .then((userData) => {
        if (userData) {
          dispatch(loginSuccess({ user: userData }));
        } else {
          dispatch(logout());
          navigate("/login", { replace: true });
        }
      })
      .catch(() => {
        dispatch(logout());
        navigate("/login", { replace: true });
      });
    // eslint-disable-next-line
  }, [location.pathname, dispatch, navigate]);

  // If user is not set, don't render protected content
  if (!user) return null;
  return <Outlet />;
};

function mapStateToProps(state) {
  const { user } = state.auth;
  return { user };
}

export default connect(mapStateToProps)(Protect);
